import { useFoodTopNavPosition } from "features/food/hooks/style"
import { ReactNode } from "react"

export const TopNavWrapper = ({ children }: { children: ReactNode }) => {
  const { position, width } = useFoodTopNavPosition(false)
  return (
    <div
      style={{
        position,
        width,
        zIndex: 100,
        maxWidth: "var(--app-max-width)",
        margin: "0 auto",
      }}
    >
      {children}
    </div>
  )
}
